import { Box, useTheme } from '@mui/material';

/**
 * v4 footer links (#1377, V4_ADDENDUM convention 9): "Privacy Policy · Terms
 * of Service", centered, 12px interactive links with a faint dot separator.
 * These appear ONLY at the end of the Dashboard scroll and on the Account
 * page - nowhere else.
 *
 * @param {object} props
 * @param {object} [props.sx]  extra sx merged onto the footer
 */
const FooterLinks = ({ sx, ...rest }) => {
  const theme = useTheme();
  const { palette } = theme;

  const linkSx = {
    color: palette.interactive,
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
  };

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        padding: { xs: '18px 0 0', md: '12px 0 0' },
        fontSize: '12px',
        ...sx,
      }}
      {...rest}
    >
      <Box component="a" href="/privacy" sx={linkSx}>Privacy Policy</Box>
      <Box component="span" sx={{ color: palette.text.faint }}>·</Box>
      <Box component="a" href="/terms" sx={linkSx}>Terms of Service</Box>
    </Box>
  );
};

export default FooterLinks;
